import { Component, NO_ERRORS_SCHEMA } from '@angular/core';

import { FieldType, FORMLY_CONFIG, FormlyModule } from '@ngx-formly/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-toggle',
  styleUrls: ['form-toggle.component.scss'],
  imports: [
    FormlyModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  template: `
    @if (props.label) {
      <label
        for="toggle-{{ this.field.key }}"
        class="section w-100"
        tabindex="0"
        [innerHTML]="props.label"
      ></label>
    }
    @if (props.help) {
      <span
        matTooltip="{{ props.help }}"
        aria-label="help"
        tabindex="0"
        [matTooltipPosition]="'above'"
        [matTooltipClass]="'rb-tooltip'"
      >
        <mat-icon class="col-1 help-icon"> help </mat-icon>
      </span>
    }
    <mat-slide-toggle
      id="type-ahead-{{ this.field.key }}"
      class="w-100"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
    />
    @if (
      formControl.hasError('required') && !formControl.hasError('regRequired')
    ) {
      <mat-error>This field is required</mat-error>
    }
    @if (formControl.hasError('regRequired')) {
      <mat-error>
        This field is needed for suitability review. You can opt out below if
        the applicant refuses to provide the information.
      </mat-error>
    }
  `,
})
export class FormlyToggleComponent extends FieldType {}
